<template lang="pug">
  div
    search_component(@search="set_search" placeholder_text='Search by shipment id')
    pagination(:page.sync="page" :itemsPerPage.sync="itemsPerPage" :items="count")

    div(v-if="status === STATUS_OK && shipments")
      shipment(v-for="shipment in shipments" :key="shipment.id" :shipment="shipment"
        :allowActions="['admin', 'worker'].indexOf(user_role) !== -1" :afterCreate="()=>{load();}")

    div(v-if="status === STATUS_OK && !shipments")
      span Shipped is empty

    .spinner-border(v-if="status === STATUS_LOADING" role='status')
      span.sr-only Loading...

    .mt-4(v-if="status === STATUS_FAIL")
      h5.text-muted.font-weight-semibold Data wasn't loaded. Please reload the page.
</template>

<script>
  import {
    STATUS_FAIL,
    STATUS_IN_PROCESS,
    STATUS_INIT,
    STATUS_LOADING,
    STATUS_OK,
    TYPE_FBA,
  } from '@/variables';
  import shipment from '@/components/in_process/shipment';
  import Pagination from '@/components/pagination/pagination';

  export default {
    data() {
      return {
        status: STATUS_INIT,
        STATUS_INIT,
        STATUS_LOADING,
        STATUS_OK,
        STATUS_FAIL,
        search: '',
        shipments: null,
        page: 1,
        count: null,
        itemsPerPage: 10,
      };
    },
    computed: {
      user_role() {
        return this.$store.state.users.role;
      },
    },
    components: { shipment, Pagination },
    created() {
      this.load();
    },
    watch: {
      page() {
        this.load();
      },
      search() {
        this.load();
      },
    },
    methods: {
      set_search(str) {
        this.search = str;
      },
      load() {
        this.status = STATUS_LOADING;

        const payload = {
          status: STATUS_IN_PROCESS,
          type: TYPE_FBA,
          page: this.page,
          search: this.search,
        };

        this.$store.dispatch('shipments/get_list', payload)
          .then((data) => {
            this.status = STATUS_OK;
            this.shipments = data.data;
            this.count = data.count;
          })
          .catch((err) => {
            console.log('catch', err);
            this.status = STATUS_FAIL;
          });
      },
    },
  };
</script>
